import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { ShortUrl } from '@air/api';

const getPublicCameraMakesListKey = ({
  shortId,
  search,
  boardId,
}: {
  shortId: string;
  search: string;
  boardId: string | undefined;
}) => {
  return ['PUBLIC_CAMERA_MAKES', { shortId, search, boardId }];
};

export const usePublicCameraMakesList = ({
  search,
  shortId,
  boardId,
}: {
  search: string;
  shortId: string;
  boardId: string | undefined;
}) => {
  const key = getPublicCameraMakesListKey({ shortId, search, boardId });

  return useQuery({
    queryKey: key,

    queryFn: async () => {
      invariant(shortId, 'Short ID is required');

      const data = await ShortUrl.getAssetVersionFilterLookups({
        limit: 20,
        shortId,
        field: 'camera.make',
        descendantBoardId: boardId,
        search,
      });

      return data.lookups.map((lookup) => lookup.value.toString());
    },
    enabled: !!shortId,
  });
};
